import { render, staticRenderFns } from "./MainMenuGerente.vue?vue&type=template&id=4af1f351&scoped=true"
import script from "./MainMenuGerente.vue?vue&type=script&lang=js"
export * from "./MainMenuGerente.vue?vue&type=script&lang=js"
import style0 from "./MainMenuGerente.vue?vue&type=style&index=0&id=4af1f351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af1f351",
  null
  
)

export default component.exports